import React from "react";
// import Router from "next/router";
// import Link from "next/link";
import {
    DropdownItem,
    DropdownMenu,
    Row,
    Container,
    Col,
    Dropdown,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    Collapse,
    Badge,
    Form,Link,
    InputGroup,
    Input,
    Button,
    InputGroupAddon,
} from "reactstrap";

const LoginHeader = ({ loginheader }) => {
    return (
        <header>

            <Navbar>

                {/* LOGO */}
                 <a href="/"  className="logo-div">
                        <img src="/image.png"></img>
                    </a>
                
                {/* END LOGO */}
              
            </Navbar>
            {/* END NAV BAR */}

        </header>
    );
};

export default LoginHeader;